const RECAPTCHA_SITE_KEY = "6LdmsQIrAAAAAFk90vfXAM38LpbvyJYsDO8eInG0";

const getRecaptchaToken = (action) => {
  return new Promise((resolve) => {
    if (!window.grecaptcha) {
      console.warn("reCAPTCHA not loaded");
      resolve("");
      return;
    }
    window.grecaptcha.ready(async () => {
      try {
        const token = await window.grecaptcha.execute(RECAPTCHA_SITE_KEY, {
          action,
        });
        resolve(token);
      } catch (e) {
        console.warn("reCAPTCHA execute failed", e);
        resolve("");
      }
    });
  });
};

export const requestDownloadPasswordReset = async (email) => {
  const endpoint = "/user/download-password-reset-request.json";
  try {
    const recaptchaResponse = await getRecaptchaToken(
      "download_password_reset",
    );

    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, recaptchaResponse }),
    });

    const data = await res.json();

    if (!res.ok) {
      throw new Error(
        data?.error?.message ||
          data?.message ||
          `Error ${res.status}: ${res.statusText}`,
      );
    }
    if (data.success === false) {
      throw new Error(
        data?.error?.message || data?.message || "Request failed",
      );
    }
    return data;
  } catch (err) {
    console.error("requestDownloadPasswordReset error:", err);
    throw err;
  }
};
